export default "__VITE_ASSET__DaGKVPO0__"